module.exports = __webpack_public_path__ + "img/bubble_3.ebe9fcf0.png";